import { useStore } from "@stores";
import { useEffect } from "react";

export const useTowns = () => {
  const { townStore } = useStore();
  const { towns, loading, loaded } = townStore;

  useEffect(() => {
    townStore.getAll();
  }, [townStore]);

  return { towns, loading, loaded };
};
